import React from 'react';

const AuthorBio = () => (
  <section
    className="author-box"
    itemProp="author"
    itemScope=""
    itemType="https://schema.org/Person"
  >
    <img
      alt="Jody Boucher's avatar"
      src="//0.gravatar.com/avatar/03ea72c498a6b52e7d95cbfb81f1b024?s=90&d=retro"
      srcSet="//0.gravatar.com/avatar/03ea72c498a6b52e7d95cbfb81f1b024?s=180&d=retro 2x"
      className="author-box--avatar"
      width="90"
      height="90"
    />
    <h1 className="author-box--title">
      About <span itemProp="name">Jody Boucher</span>
    </h1>
    <div className="author-box--content" itemProp="description">
      <p>
        I am a software developer with over a decade of experience serving both the private and
        public sectors.
      </p>
      <p>
        I pride myself on combining clean code, a strong business sense and great communication
        skills to provide clients with meaningful value.
      </p>
    </div>
  </section>
);

export default AuthorBio;



// WEBPACK FOOTER //
// ./src/components/AuthorBio.js